
import axios from 'axios'

import BaseService from './BaseService'
const Environment = require('../environments/environment.json')

const getOems = (sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Oems`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getComponentViewSettings = (componentName, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Oems/GetViewSettings/${componentName}`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const OemsService =
{
	getOems,
	getComponentViewSettings
}

export default OemsService
